import React from 'react';
import { Icon } from '@iconify/react';

const ReceiptTemplate = ({ payload }) => {
    if (!payload) return null;

    return (
        <div
            id="receipt-template"
            className="fixed top-0 -left-[9999px] w-[500px] rounded-2xl bg-slate-50 text-slate-900 p-0 font-sans shadow-xl overflow-hidden"
            style={{ zIndex: -1000 }}
        >
            {/* Liseré esthétique */}
            <div className="bg-lime-500 h-4 w-full"></div>

            <div className=" h-4 w-full absolute bottom-4 left-0 border-b-4 border-gray-300 border-dashed"></div>

            {/* Logo depuis le dossier public */}
            <img src="/assets/store/11.svg" alt="Safaridew Logo" className="w-48 h-48 object-contain absolute top-14 left-1/2 -translate-x-1/2 opacity-10 " />

            <div className="p-10">
                {/* Header */}
                <div className="flex justify-between items-start border-b border-slate-200 pb-8 mb-8 ">
                    <div className="flex items-center gap-3">

                        <div>
                            <h1 className="text-xl tracking-tighter">safaridew <span className='text-lime-800 font-serif'>STORE</span></h1>
                            <p className="text-xs text-slate-500 mt-1 uppercase flex items-center gap-2 font-semibold">
                                <Icon icon="solar:document-text-bold" className="text-lime-500" />
                                Reçu Officiel
                            </p>
                        </div>
                    </div>
                    <div className="text-right">
                        <div className="inline-block bg-lime-500/20 text-lime-700 px-4 py-2 rounded-xl text-sm font-bold border-[1px] border-lime-500/30">
                            STATUT: PAYÉ
                        </div>
                        <p className="text-xs text-slate-500 mt-3 font-mono">
                            {new Date(payload.createdAt).toLocaleString()}
                        </p>
                        <p className="text-xs text-slate-500 font-mono">
                            REF: {payload.payment?.reference}
                        </p>
                    </div>
                </div>

                {/* Client Info Grid */}
                <div className="grid grid-cols-2 gap-8 mb-10">
                    <div className="bg-white p-5 rounded-2xl border-[1px] border-slate-200 shadow-sm">
                        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                            <Icon icon="solar:user-bold" className="text-lime-500 text-lg" /> Client
                        </h3>
                        <p className="font-bold text-lg">{payload.customer?.name}</p>
                        <p className="text-sm text-slate-600">{payload.customer?.phone}</p>
                        <p className="text-sm text-slate-600">{payload.customer?.email || 'Aucun e-mail spécifié'}</p>
                    </div>
                    <div className="bg-white p-5 rounded-2xl border-[1px] border-slate-200 shadow-sm">
                        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                            <Icon icon="solar:map-point-bold" className="text-lime-500 text-lg" /> Livraison
                        </h3>
                        <p className=" text-lg">{payload.delivery?.city}</p>
                        <p className="text-sm text-slate-600">{payload.delivery?.mode}</p>
                        <p className="text-sm text-slate-600 mt-1">{payload.customer?.address}</p>
                    </div>
                </div>

                {/* Items Table */}
                <div className="bg-white rounded-2xl border-[1px] border-slate-300 shadow-sm overflow-hidden mb-10">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-slate-50 text-slate-500 border-b border-slate-200">
                            <tr>
                                <th className="py-4 px-6 font-semibold uppercase tracking-wider text-xs">Désignation</th>
                                <th className="py-4 px-6 font-semibold uppercase tracking-wider text-xs w-24 text-center">Qté</th>
                                <th className="py-4 px-6 font-semibold uppercase tracking-wider text-xs w-32 text-right">Montant</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {payload.items?.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="py-4 px-1 font-medium text-slate-700 truncate">{item.name}</td>
                                    <td className="py-4 px-1 text-center text-slate-500 font-mono">x{item.qty}</td>
                                    <td className="py-4 px-4 text-right font-medium text-slate-700 font-mono">{item.total} $US</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Totals */}
                <div className="flex justify-end relative">
                    {/* Fake stamp */}
                    <Icon icon="solar:check-read-linear" className="absolute left-10 -top-6 text-8xl text-lime-500/10 rotate-[-15deg] pointer-events-none" />
                    <div className="w-80 space-y-3 relative z-10">
                        <div className="flex justify-between text-sm text-slate-500 px-4 font-medium">
                            <span>Sous-total</span>
                            <span className="font-mono">{Number(payload.summary?.subtotal || 0).toFixed(2)} $US</span>
                        </div>
                        <div className="flex justify-between text-sm text-slate-500 px-4 font-medium">
                            <span>Frais Livraison</span>
                            <span className="font-mono">{Number(payload.summary?.shippingCost ?? payload.summary?.shipping ?? 0).toFixed(2)} $US</span>
                        </div>
                        <div className="flex justify-between items-center text-lg bg-lime-500/20 border-[1px] border-gray-300 p-2 rounded-xl shadow-sm">
                            <span>Total Final</span>
                            <span className="text-lime-900 font-mono text-2xl tracking-tighter">{Number(payload.summary?.total || 0).toFixed(2)} $US</span>
                        </div>
                    </div>
                </div>

                {/* Footer Message */}
                <div className="mt-16 text-center text-sm text-slate-400 flex flex-col items-center gap-2">
                    <p className="font-medium text-slate-500">Merci pour votre confiance !</p>
                    <p className="text-xs uppercase tracking-widest mt-1">N° {payload.payment?.orderNumber}</p>

                    {/* Contact Info */}
                    <div className="flex items-center justify-between gap-6 pt-6 border-t w-full border-slate-200">
                        <div className="flex items-center gap-2 text-slate-500">
                            <Icon icon="ic:baseline-whatsapp" className="text-lime-600 text-lg" />
                            <span className="font-mono text-xs">+243 85 060 5759</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-500">
                            <Icon icon="solar:global-bold" className="text-lime-600 text-lg" />
                            <span className="font-mono text-xs">www.safaridew.vercel.app</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReceiptTemplate;
